<template>
  <v-hover v-slot="{ hover }">
    <v-card
      :width="isVideoUrl ? '640' : '350'"
      class="my-1 card-content ml-1 cardified"
      @dblclick="useUpdateFlair({ flair: 'cardify', enableState: 'toggle' })"
    >
      <!-- <v-col
        class="shrink handle pa-0"
        :class="'a' + parentNoteId"
        style="position: absolute; left: -32px; width: 28px; z-index: 1;"
      >
        <v-menu v-model="noteMenuValue" offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn icon small v-on="on" class="hover-only ghost">
              <v-icon small>drag_indicator</v-icon>
            </v-btn>
          </template>
          <flair-menu
            :page="page"
            :enabledFlair="enabledFlair"
            @updateFlair="useUpdateFlair"
            @pinOpen="addPinnedId(pageId)"
            @zoom="
              setZoomedCardId(pageId);
              noteMenuValue = false;
            "
            @moveTo="
              openMoveTo({ selectedNoteId: parentNoteId, parentPageId });
              noteMenuValue = false;
            "
            @open="
              setFocusedCardId(pageId);
              noteMenuValue = false;
            "
            @selectNote="
              $emit('selectNote');
              noteMenuValue = false;
            "
            @deleteNote="
              $emit('deleteNote');
              noteMenuValue = false;
            "
            @indent="$emit('indentCard', $event)"
            @deindent="$emit('deIndentCard', $event)"
            @addNewLineBelow="
              $emit('addNewLineBelow', { pageType: page.type });
              noteMenuValue = false;
            "
            @addNewLineAbove="
              $emit('addNewLineAbove', { pageType: page.type });
              noteMenuValue = false;
            "
            @moveUp="$emit('moveOrder', -1)"
            @moveDown="$emit('moveOrder', 1)"
            @moveTop="$emit('moveFirst')"
            @moveBottom="$emit('moveLast')"
          ></flair-menu>
        </v-menu>
      </v-col> -->
      <div style="position: relative">
        <template v-if="isImageUrl">
          <v-img :src="firstLink" max-height="300px" position="top center"></v-img>
        </template>
        <template v-if="isVideoUrl">
          <you-tube-player :video-id="videoId" width="100%"></you-tube-player>
        </template>
        <v-row v-if="isImageUrl || isVideoUrl" no-gutters>
          <v-col class="caption text-truncate px-4 py-1 text-right" v-html="page.title"> </v-col>
        </v-row>
        <v-card-title v-else v-html="page.title" class="pb-0" :class="isQuote ? 'quote' : ''">
        </v-card-title>

        <!-- <v-speed-dial
          absolute
          bottom
          right
          direction="right"
          open-on-hover
          transition="slide-x-transition"
        >
          <template v-slot:activator>
            <v-fab-transition>
              <v-btn
                v-show="hover"
                color="blue"
                dark
                fab
                x-small
                @click.stop="setFocusedCardId(page.id)"
              >
                <v-icon style="transform: rotate(90deg);">
                  arrow_circle_up
                </v-icon>
              </v-btn>
            </v-fab-transition>
          </template>
        </v-speed-dial> -->
      </div>
      <v-card-text v-if="childNotes.length" class="pl-5 pt-2 card-text row no-gutters">
        <cardify-card-child
          v-for="(note, index) in childNotes"
          :note="note"
          :key="note.id"
          :index="index"
        ></cardify-card-child>
      </v-card-text>
    </v-card>
  </v-hover>
</template>

<script>
import { computed, ref, watch } from '@vue/composition-api';
import { getIdFromURL, getTimeFromURL, YouTubePlayer } from 'vue-youtube-embed';
import FlairMenu from './FlairMenu';
import useFlair from './use/useFlair';
import CardifyCardChild from './CardifyCardChild';
import useContext from '@/views/Context/use/useContext';
export default {
  props: ['page', 'parentNoteId', 'parentPageId'],
  components: {
    FlairMenu,
    CardifyCardChild,
    YouTubePlayer
  },
  setup(props) {
    const firstLink = computed(() => {
      const div = document.createElement('div');
      div.innerHTML = props.page.title;
      const a = div.querySelector('a');
      console.log(a);
      return a ? a.href : false;
    });

    const isImageUrl = computed(() => {
      console.log(firstLink, props.page);
      return firstLink.value && firstLink.value.match(/\.(jpeg|jpg|gif|png)$/) != null;
    });

    const isVideoUrl = computed(() => {
      console.log(firstLink, props.page);
      return firstLink.value && firstLink.value.match('youtube') != null;
    });

    const videoId = computed(() => {
      return isVideoUrl.value ? getIdFromURL(firstLink.value) : false;
    });

    const isQuote = computed(() => {
      return props.page.type == 13;
    });

    const childNotes = computed(() =>
      Object.values(props.page.pageNotes)
        .filter(n => !n.toDelete && n !== undefined && n.id)
        .sort((a, b) => (a.order > b.order ? 1 : -1))
    );

    const { updateFlair } = useFlair();
    const useUpdateFlair = ({ flair, value = undefined, enableState = false }) => {
      const pageId = props.page.id;
      updateFlair({
        noteId: props.parentNoteId,
        parentPageId: props.parentPageId,
        pageId,
        flair,
        value,
        enableState
      });
    };

    const { setFocusedCardId, setZoomedCardId } = useContext();

    return {
      isImageUrl,
      isVideoUrl,
      videoId,
      firstLink,
      isQuote,
      useUpdateFlair,
      childNotes,
      setFocusedCardId,
      setZoomedCardId
    };
  },
  data() {
    return {
      noteMenuValue: false
    };
  },
  computed: {
    enabledFlair: {
      get() {
        return this.page.flair && this.page.flair.enabled ? this.page.flair.enabled : [];
      },
      set(v) {
        console.log('enable', v);
        this.useUpdateFlair({ key: 'enabled', value: v });
      }
    }
  }
};
</script>

<style>
.cardified .quote p {
  border-left: 6px solid #b5b5b5;
  padding-left: 10px;
}

.cardified .card-text .quote p {
  border-left: 3px solid #dadada;
  padding-left: 10px;
}

.cardified p {
  margin-bottom: 0px;
  word-break: break-word;
}

.cardified .text-truncate p {
  display: inline;
}
</style>
